import * as React from 'react';

import type {EntitySummaryRating} from 'nutshell-graphql-types';

import {Popover} from '../../popover/popover';

import {LeadSummary} from './lead-summary';

import styles from './lead-summary-popover.module.css';

type Props = {
    anchor: HTMLElement | null | undefined;
    anchorElementId: string;
    recap: string;
    nextSteps: string[];
    entityId?: string;
    userRating?: EntitySummaryRating | null | undefined;
    onRate?: (rating: EntitySummaryRating) => Promise<any>;
    isSavingRating?: boolean;
    onRefresh?: () => Promise<any>;
    onFeedback?: () => void;
    onLearnMore?: () => void;
};

export function LeadSummaryPopover(props: Props) {
    return (
        <Popover
            anchor={props.anchor}
            anchorElementId={props.anchorElementId}
            location='right'
            bodyColor='light'
            hideNub={true}
            // @ts-expect-error
            width={500}
            noDefaultStyling={true}
            shouldFadeIn={true}
        >
            <div className={styles.container}>
                <LeadSummary
                    recap={props.recap}
                    nextSteps={props.nextSteps}
                    hasPadding={false}
                    entityId={props.entityId}
                    userRating={props.userRating}
                    onRate={props.onRate}
                    isSavingRating={props.isSavingRating}
                    onRefresh={props.onRefresh}
                    onFeedback={props.onFeedback}
                    onLearnMore={props.onLearnMore}
                />
            </div>
        </Popover>
    );
}
